import { connect } from 'react-redux';
import {
    getSelectedEnterpriseCustomCheckoutLegalStatements,
    getSelectedEnterpriseLegalStatements,
} from '../../../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ApplicationState } from '../../../../types';

export const inject = connect((state: ApplicationState) => ({
    statements: getSelectedEnterpriseLegalStatements(state, {}),
    textKeyStatements: getSelectedEnterpriseCustomCheckoutLegalStatements(state),
}));
